import i18n from '@/locales'

export default {
  created () {
    this.singleActions = [
      {
        type: 'mapping',
        label: i18n.t('table.action.modify'),
        permission: 'bill_product_update',
        action: (obj) => {
          this.createDialog('BillProductUpdateDialog', {
            data: [obj],
            onManager: this.onManager,
          })
        },
      },
      {
        type: 'mapping',
        label: i18n.t('compute.perform_delete'),
        permission: 'bill_product_delete',
        action: (obj) => {
          this.createDialog('DeleteResDialog', {
            vm: this,
            data: [obj],
            columns: this.columns,
            title: this.$t('table.action.delete'),
            name: this.$t('bill.mapping'),
            onManager: this.onManager,
          })
        },
        meta: (obj) => this.$getDeleteResult(obj),
      },
    ]
  },
}
